import { ResponseData } from "@/typings";
import { fetchTrackApi } from "@/utils/fetch";
import { GetTrackingRecordSaveParams } from "./interface";
import { TrackingPlatform, UtmList } from "@/shared";
import { clientWindow, isServerRendering } from "@/utils/dom";
import { getUriQuery } from "@/utils/url";
import { generateFingerprint } from "@/utils/deviceInfo";

const trackingRecordSaveParams = {
  platform: TrackingPlatform.H5,
  report_time: Math.floor(new Date().getTime() / 1000),
};

export const utmData = () => {
  const url = clientWindow?.location?.href || "";
  const [, search] = url.split("?");
  const urlQuery = getUriQuery(search || "", UtmList);
  return urlQuery;
};

const extUrlData = (params: GetTrackingRecordSaveParams) => {
  const url = clientWindow?.location?.href || "";
  const utmQuery = utmData();
  const { ext } = params;
  const newExt = { ...utmQuery, url, ...ext };
  return newExt;
};

export async function fetchTrackingRecordSave(
  params: GetTrackingRecordSaveParams
) {
  const deviceId = isServerRendering ? "" : await generateFingerprint();
  return fetchTrackApi<ResponseData<null>>("v1/tracking-record/save", {
    method: "POST",
    body: JSON.stringify({
      ...trackingRecordSaveParams,
      ...params,
      ...utmData(),
      ext: JSON.stringify(extUrlData(params)),
      device_id: deviceId,
    }),
  });
}
